/**
 * Общие компоненты для игр OwlCat Club
 * Экспорт всех универсальных игровых компонентов
 */

export { GameLayout } from './GameLayout';
export { GameVictoryModal } from './GameVictoryModal';
export { UniversalGameHeader } from './UniversalGameHeader';
export { DifficultySelector } from './DifficultySelector';
export { GameRulesModal } from './GameRulesModal';

// Типы и интерфейсы
export type {
  BaseGame,
  BaseGameSettings,
  GameStatus,
  GameDifficulty,
  GameResult,
  UseGameStateReturn,
  UseGameTimerReturn,
  UseFullscreenReturn,
  UseGameSettingsReturn,
} from '@/contexts/games/types';

// Хуки
export { useGameState } from '@/contexts/games/hooks/useGameState';
export { useGameTimer } from '@/contexts/games/hooks/useGameTimer';
export { useGameSettings } from '@/contexts/games/hooks/useGameSettings';
export { useFullscreen } from '@/contexts/games/hooks/useFullscreen';
